import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router'
import { userActions } from '../../actions/user.actions';
import "./styles.css";

export default class HomeScreen extends Component {
  state = {activeItem: ''}

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Redirect to="/requests" />
    )
  }
}

function mapStateToProps(state) {
    const { users, authentication } = state;
    const { user } = authentication;
    return {
        user,
        users
    };
}

const connectedHomeScreen = connect(mapStateToProps)(HomeScreen);
export { connectedHomeScreen as HomeScreen };
